import React from 'react'
import Bottom from '../Bottom'
import './index.module.less'
export default () => {
  return <div styleName="container">
    <div styleName="center">
      <div styleName="logo" />
      <div styleName="logo-txt"></div>
    </div>
    <Bottom />
  </div>
}